import React from 'react'
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'

export default props => {
    useStyles(classes)
    return <span className={classes.Placeholder}>{props.title}</span>
}